import { tsUtils } from '@neo-one/ts-utils';
export const hasInput = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isInput(context, node, tpe));
export const isOnlyInput = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isInput(context, node, tpe));
export const isInput = (context, node, type) => context.builtins.isInterface(node, type, 'Input');

//# sourceMappingURL=typeTests.js.map
